import classNames from 'classnames';
import React from 'react';

import {Entity} from 'constants/UserConstants';
import Col from 'ui-library/bs/Col';
import FormInput from 'ui-library/bs/FormInput';
import Row from 'ui-library/bs/Row';
import HorizontalThrobber from 'ui-library/HorizontalThrobber';

interface EntityListProps {
  entities: Array<Entity>;
  onChange: (initials: string, index: number) => void;
  type: string;
  validate: (initials?: string) => string | null;
}

function EntityList({entities, onChange, type, validate}: EntityListProps): JSX.Element {
  const rows = entities.map((entity, i) => (
    <EntityRow
      key={entity.handle}
      index={i}
      entity={entity}
      onChange={onChange}
      type={type}
      validate={validate}
    />
  ));

  return (
    <div>
      {rows.length > 0 ? (
        rows
      ) : (
        <span className="u-tiny-spacing-top u-small-spacing-left">
          <HorizontalThrobber />
        </span>
      )}
    </div>
  );
}

interface EntityRowProps {
  entity: Entity;
  index: number;
  onChange: (initials: string, index: number) => void;
  type: string;
  validate: (initials?: string) => string | null;
}

function EntityRow({entity, index, onChange, type, validate}: EntityRowProps): JSX.Element {
  const error = validate(entity.initials);
  return (
    <Row className="membersScreen-list-row">
      <Col sm={4} className="membersScreen-list-handle">
        {entity.handle}
        <div className="membersScreen-member-subtext">{type}</div>
      </Col>
      <Col sm={4} className="membersScreen-list-name">
        {entity.name}
      </Col>
      <Col sm={4}>
        <FormInput
          className={classNames('membersScreen-input', {error})}
          value={entity.initials}
          placeholder="Enter initials"
          onChange={(event) => {
            onChange(event.target.value, index);
          }}
        />
        <div className="membersScreen-input-errorMessage">{error}</div>
      </Col>
    </Row>
  );
}

export default EntityList;
